// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RDgYr","wrapper":"styles_wrapper__yAy-2","image":"styles_image__QkMWv","heading":"styles_heading__cR95A","para":"styles_para__2DPbH"};